import { QuarantineLogItem } from '../utils/types';

export enum QuarantineItemModalName {
  None = 'none',
  Delete = 'delete',
  Download = 'download',
  ContentPreview = 'contentPreview',
  Restore = 'restore',
  RestoreAll = 'restoreAll',
}

export type QuarantineItemModalState =
  | {
      name: Exclude<
        QuarantineItemModalName,
        QuarantineItemModalName.None | QuarantineItemModalName.ContentPreview
      >;
      quarantineItems: QuarantineLogItem[];
    }
  | {
      name: QuarantineItemModalName.ContentPreview;
      quarantineItems: [QuarantineLogItem];
    }
  | {
      name: QuarantineItemModalName.None;
      quarantineItems: QuarantineLogItem[];
    };
// | {
//     name: QuarantineItemModalName.RestoreAll;
//     quarantineItems: [];
//   };

export enum QuarantineSettingModalName {
  None = 'none',
  Gmail = 'gmail',
  OneDrive = 'oneDrive',
  ExchangeOnline = 'exchangeOnline',
}

export type QuarantineSettingModalState =
  | {
      name: Exclude<
        QuarantineSettingModalName,
        QuarantineSettingModalName.None
      >;
      todo: any;
    }
  | {
      name: QuarantineSettingModalName.None;
      todo: null;
    };
